import { render, staticRenderFns } from "./FrmRecoverPassword.vue?vue&type=template&id=d1e11cec"
import script from "./FrmRecoverPassword.vue?vue&type=script&lang=js"
export * from "./FrmRecoverPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports